type AuthTermsDisclosureProps = {
  termsText?: string | null
  privacyText?: string | null
  emptyMessage?: string | null
  className?: string
}

export function AuthTermsDisclosure({
  termsText,
  privacyText,
  emptyMessage,
  className = '',
}: AuthTermsDisclosureProps) {
  const resolvedTermsText = String(termsText ?? '').trim()
  const resolvedPrivacyText = String(privacyText ?? '').trim()
  const resolvedEmptyMessage = String(emptyMessage ?? '').trim()
  const hasPolicyText = resolvedTermsText.length > 0 || resolvedPrivacyText.length > 0

  if (!hasPolicyText && !resolvedEmptyMessage) {
    return null
  }

  return (
    <details className={`text-xs text-muted-foreground ${className}`.trim()}>
      <summary className="cursor-pointer font-medium text-primary hover:underline">
        Terms and conditions
      </summary>
      <div className="mt-3 max-h-40 space-y-3 overflow-y-auto rounded-md border bg-muted/30 p-3 leading-5">
        {resolvedTermsText ? (
          <div className="space-y-1">
            <p className="font-medium text-foreground">Terms and conditions</p>
            <p className="whitespace-pre-wrap">{resolvedTermsText}</p>
          </div>
        ) : null}
        {resolvedPrivacyText ? (
          <div className="space-y-1">
            <p className="font-medium text-foreground">Privacy policy</p>
            <p className="whitespace-pre-wrap">{resolvedPrivacyText}</p>
          </div>
        ) : null}
        {!hasPolicyText && resolvedEmptyMessage ? <p>{resolvedEmptyMessage}</p> : null}
      </div>
    </details>
  )
}
